import { isEqual } from 'lodash'
import { CreateLocalizationFormType, EditLocalizationFormType, ProductLocalizedKeys } from './types'

export const hasAnyChangesFromDefault = (
  formValues: EditLocalizationFormType | CreateLocalizationFormType,
  product: ProductLocalizedKeys | null
) => {
  if (product === null) return true
  if (formValues.name !== product.name) return true
  if (formValues.description !== product.description) return true
  if (formValues.lineage !== product.category) return true
  if (
    (product?.brand_subtype !== null && formValues.category_label !== product?.brand_subtype) ||
    (product?.brand_subtype === null && formValues.category_label !== '')
  )
    return true
  if (!isEqual(formValues.image_urls, product.image_urls)) return true
  return false
}

export const validateCreate = (values: CreateLocalizationFormType) => {
  const errors = commonValidations(values)

  if (!values.state_selector) {
    errors.state_selector = 'State is required'
  }

  return errors
}

export const validateEdit = (values: EditLocalizationFormType) => {
  const errors = commonValidations(values)
  return errors
}

const commonValidations = (values: { name: string; description: string }) => {
  const errors: { [key: string]: string } = {}

  if (values.name === '') {
    errors.name = 'Name cannot be blank'
  }

  if (values.description === '') {
    errors.description = 'Description cannot be blank'
  }

  return errors
}
